import { FC } from 'react';

import { IcCloseLargeIcon, IcPlusIcon } from '@gem/icons';
import { IconButton, IconViewSizes, PopoverMenu } from '@gem/ui-kit';

import { useNewMessageButtonPresenter } from './NewMessageButton.presenter';
import styles from './NewMessageButton.styles.m.css';

export const NewMessageButton: FC = () => {
  const { presenter, popover } = useNewMessageButtonPresenter();

  return (
    <>
      <IconButton
        className={styles.button}
        iconClassName={styles.icon}
        setRef={popover.containerRef}
        Icon={popover.isOpened ? IcCloseLargeIcon : IcPlusIcon}
        size={IconViewSizes.Large}
        iconSize={IconViewSizes.Medium}
        theme="20"
        dataTest="new-message-button"
        onClick={popover.toggle}
      />

      <PopoverMenu
        className={styles.menu}
        isOpened={popover.isOpened}
        menuItems={presenter.menuItems}
        onClose={popover.close}
        reference={popover.containerRef.current}
        placement="top-end"
      />
    </>
  );
};
